/**
 * Unterziele großer Orte (Terminals eines Flughafens, Eingänge einer Klinik)
 * aus `Place.subDestinations` der Places API
 * (nextcab_mobile/docs/general/adressauswahl_konzept.md §2.2).
 *
 * Der Google-Punkt solcher Orte liegt oft auf dem Gelände (Flughafen Hamburg:
 * 680 m neben der Vorfahrt), die Navigation führt dann auf Umwege. Gewählt
 * wird deshalb ein Unterziel; der Hauptpunkt wird nicht angeboten.
 * Gleiche Regeln wie in der App (`PlacesAutocompleteService`).
 */

/**
 * „Flughafenstr. 1-3/Terminal 1 Ankunft" → „Terminal 1 Ankunft",
 * „Parkhaus P5 Terminal - Flughafen Hamburg" → „Parkhaus P5 Terminal".
 */
export const subDestinationLabel = (displayName = '', mainName = '') => {
  const original = String(displayName).trim();
  let label = original;
  const slash = label.lastIndexOf('/');
  if (slash >= 0 && slash < label.length - 1) {
    label = label.slice(slash + 1).trim();
  }
  if (mainName) {
    const escaped = mainName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    label = label.replace(new RegExp(`\\s*[-–]\\s*${escaped}$`), '').trim();
  }
  return label || original;
};

/** „Flughafen Hamburg – Terminal 1 Abflug" — geocodiert exakt aufs Unterziel zurück. */
export const subDestinationAddress = (mainName, label) =>
  mainName ? `${mainName} – ${label}` : label;

/**
 * Sortierung je Rolle: Abholung „Ankunft" zuerst, Ziel „Abflug" zuerst,
 * sonst Google-Reihenfolge. Parkhäuser bleiben bewusst drin.
 *
 * @param {Array<{label: string}>} options
 * @param {'pickup'|'destination'|'stop'} role
 */
export const sortSubDestinations = (options, role) => {
  const preferred = { pickup: 'ankunft', destination: 'abflug' }[role];
  if (!preferred) return options;
  const hit = (o) => o.label.toLowerCase().includes(preferred);
  return [...options.filter(hit), ...options.filter((o) => !hit(o))];
};

/**
 * Aus geladenen Unterziel-Places (displayName + location) die Auswahlliste.
 * Places ohne Namen oder Punkt fallen weg.
 */
export const buildSubDestinationOptions = (places, mainName, role) => {
  const options = [];
  (places || []).forEach((place) => {
    const name = place?.displayName;
    const location = place?.location;
    if (!name || !location) return;
    const label = subDestinationLabel(name, mainName);
    options.push({
      label,
      address: subDestinationAddress(mainName, label),
      location: { latitude: location.lat(), longitude: location.lng() },
    });
  });
  return sortSubDestinations(options, role);
};
